<div class="container">
  <h1 class="display-5 fw-semibold">Galería de fotos</h1>

  <h5>Álbumes destacados</h5>

  <div class="row g-2">
    @for (album of firstAlbums; track album.id) {
      @if (album.photos) {
        <div class="col-md-4 mb-4">
          <a [routerLink]="['/album', album.title]">
            <div class="card text-bg-dark">
              <img
                [src]="album.photos[0].image_url"
                class="card-img opacity-50 object-fit-cover"
                alt=""
                height="284"
              />
              <div
                class="card-img-overlay d-flex flex-column justify-content-end align-items-start"
              >
                <span class="text-uppercase">
                  {{ album.created_at | date: 'MMMM d, y' }}
                </span>
                <h6>{{ album.title }}</h6>
              </div>
            </div>
          </a>
        </div>
      }
    } @empty {
      @for (i of [1, 2, 3]; track i) {
        <div class="col-md-4 mb-4 placeholder-glow">
          <span class="placeholder w-100" style="height: 284px"></span>
        </div>
      }
    }
  </div>

  <h5>Más álbumes</h5>

  <p class="text-body-secondary placeholder-glow">
    @if (albums.length === 0) {
      <span class="placeholder col-1"></span>
    } @else {
      {{ albums.length }} en total
    }
  </p>

  <div class="row g-2 mb-2">
    @for (album of albums; track album.id) {
      <div class="col-md-3">
        <a [routerLink]="['/album', album.title]">
          <div class="card text-bg-dark">
            @if (album.photos) {
              <img
                [src]="album.photos[0].image_url"
                class="card-img opacity-50 object-fit-cover"
                alt=""
                height="212"
              />
            } @else {
              <img
                src="/assets/img/placeholder.png"
                class="card-img opacity-50 object-fit-cover"
                alt=""
                height="212"
              />
            }
            <div
              class="card-img-overlay d-flex flex-column justify-content-end align-items-start"
            >
              <span class="text-uppercase">
                {{ album.created_at | date: 'MMMM d, y' }}
              </span>
              <h6>{{ album.title }}</h6>
            </div>
          </div>
        </a>
      </div>
    } @empty {
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="col-md-3 placeholder-glow">
          <span class="placeholder w-100" style="height: 212px"></span>
        </div>
      }
    }
  </div>
</div>
